import React from 'react';
import { FormattedMessage } from 'react-intl';
import { div } from '../../helpers/components';
import { theme } from '../../styles';
import { NullState } from '../null-state/NullState';

export const ResultsCountWrapper = div({
  //marginBottom: '0.75rem',
  color: theme.gray600,
  fontWeight: 400,
  fontSize: '0.9rem',
});

interface Props {
  count?: number;
  children?: React.ReactNode;
  noMargin?: boolean;
  noCustomEmptyState?: boolean;
}

export const ResultsCount = (props: Props) => {
  const { count, children: _children } = props;
  const children = _children || (
    <FormattedMessage
      id="common.resultsCount"
      defaultMessage="{count, plural, zero {Sin resultados}one {1 resultado}other {# resultados}}"
      values={{ count }}
    />
  );

  if (!count && !props.noCustomEmptyState) {
    return (
      <div data-cy="results-count">
        <NullState className={props.noMargin ? '' : 'p-7'}>{children}</NullState>
      </div>
    );
  }

  return <ResultsCountWrapper data-cy="results-count">{children}</ResultsCountWrapper>;
};
